import React, { useState } from 'react'
import {
  ImagePreviewWrapper,
  ImagePreviewWrapperSizeEnum,
} from 'UiKitComponents/ImagePreviewWrapper/ImagePreviewWrapper'
import { IBuffetGeneralReportResult } from 'core/api/dto/BuffetGeneralReportDto'
import { ReportTempView } from 'pages/BuffetLinePage/ReportPage/ReportPage'
import { SetURLSearchParams } from 'react-router-dom'
import { SubTableRepresentFull } from './SubTableRepresentFull'
import { useTranslation } from 'react-i18next'
import { IHeaderData } from 'components/AppTable/AppTable'
import { headerDataFirstValue } from 'components/AppTable/components/headerDataFirstValue'
import { AppTableDndMobile } from 'components/AppTable/AppTableDndMobile'

const headerData = [
  {
    title: 'Наименование',
    colWidth: '22%',
    sort: 'name',
    order: 0,
    startPosition: 0,
  },
  {
    title: 'Категория',
    colWidth: '3%',
    sort: 'categoryName',
    order: 1,
    startPosition: 1,
  },
  { title: 'Станция', colWidth: '10%', order: 2, startPosition: 2 },
  { title: 'Дата', colWidth: '15%', order: 3, startPosition: 3 },
  { title: 'Время', colWidth: '3%', order: 4, startPosition: 4 },
  { title: 'Название план-меню', colWidth: '3%', order: 5, startPosition: 5 },
  { title: 'Тип гостя', colWidth: '3%', order: 6, startPosition: 6 },
  { title: 'Тип замера', colWidth: '3%', order: 7, startPosition: 7 },
  { title: 'Значение типа замера', colWidth: '3%', order: 8, startPosition: 8 },
  {
    title: 'Кол-во замеров',
    colWidth: '3%',
    sort: 'dimensionsCount',
    order: 9,
    startPosition: 9,
  },
  {
    title: 'Порядковый номер замера',
    colWidth: '3%',
    order: 10,
    startPosition: 10,
  },
  {
    title: 'Заявленый вес в план-меню, кг',
    colWidth: '3%',
    sort: 'plannedWeight',
    order: 11,
    startPosition: 11,
  },
  {
    title: 'Заявленое кол-во персон, человек',
    colWidth: '3%',
    order: 12,
    startPosition: 12,
  },
  {
    title: 'Заявленный вес на персону, кг',
    colWidth: '3%',
    order: 13,
    startPosition: 13,
  },
  {
    title: 'Название тары',
    colWidth: '25%',
    order: 14,
    startPosition: 14,
  },
  {
    title: 'Вес тары, кг',
    colWidth: '3%',
    order: 15,
    startPosition: 15,
  },
  {
    title: 'Фактический общий вес, кг',
    colWidth: '3%',
    order: 16,
    startPosition: 16,
  },
  {
    title: 'Фактический вес без тары,кг',
    colWidth: '3%',
    sort: 'actualWeight',
    order: 17,
    startPosition: 17,
  },
  {
    title: 'Фактическое кол-во персон, человек',
    colWidth: '3%',
    sort: 'actualPersonsAmount',
    order: 18,
    startPosition: 18,
  },

  {
    title: 'Фактический вес на персону, кг',
    colWidth: '3%',
    sort: 'actualWeightPerPerson',
    order: 19,
    startPosition: 19,
  },
  {
    title: 'Разница кол-во персон, человек',
    colWidth: '3%',
    sort: 'personsAmountDiff',
    order: 20,
    startPosition: 20,
  },
  {
    title: 'Разница вес, кг',
    colWidth: '3%',
    order: 21,
    startPosition: 21,
  },
  {
    title: 'Эталонная температура продукта мин - макс, °C',
    colWidth: '3%',
    sort: 'standardTempMax',
    order: 22,
    startPosition: 22,
  },
  {
    title: 'Фактическая температура продукта мин - сред- макс, °C',
    colWidth: '25%',
    sort: 'temperatureAvg',
    order: 23,
    startPosition: 23,
  },
  {
    title: 'Соответствие продукта темп режиму  ',
    colWidth: '3%',
    order: 24,
    startPosition: 24,
  },
  { title: 'Фото', colWidth: '5%', order: 25, startPosition: 25 },
]

interface IReportFullProps {
  reportData: IBuffetGeneralReportResult[]
  setSearchParams: SetURLSearchParams
  setCurrentSortValue: React.Dispatch<React.SetStateAction<string | null>>
}

export const ReportFull = ({
  reportData,
  setSearchParams,
  setCurrentSortValue,
}: IReportFullProps) => {
  const [toggleAllState, setToggleAllState] = useState<number[]>([])
  const { t } = useTranslation()
  const [headerDataDnd, setHeaderData] = useState<IHeaderData[]>(
    headerDataFirstValue('editable-equipment-products-table', headerData),
  )
  const subTableRepresentFn = (
    item: IBuffetGeneralReportResult,
    currentCol?: number,
    itemIndex?: number,
    onTouchStart?: ((e: React.TouchEvent) => void) | undefined,
    onTouchMove?: ((e: React.TouchEvent) => void) | undefined,
    width?: number,
    toggleAllState?: number[],
    headerData?: IHeaderData[],
  ) => (
    <SubTableRepresentFull
      item={item}
      currentCol={currentCol}
      itemIndex={itemIndex}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      width={width}
      toggleAllState={toggleAllState}
      toggleAllStateFullLenght={reportData.length}
      headerData={headerData}
    />
  )

  return (
    <React.Fragment>
      {reportData && (
        <AppTableDndMobile<
          IBuffetGeneralReportResult,
          keyof IBuffetGeneralReportResult
        >
          setHeaderData={setHeaderData}
          toggleAllState={toggleAllState}
          setToggleAllState={setToggleAllState}
          tableName="report-table"
          data={{
            count: 0,
            results: reportData,
            previous: '',
            next: '',
          }}
          tableWrapperClassName={'buffet-report-table'}
          tableCellClassName={'buffet-report-page-table-cell'}
          rowClassName={'buffet-report-page-table-category'}
          setCurrentSortFn={setCurrentSortValue}
          tableDataSelectors={[
            {
              renderItem: (item, index) => (
                <div
                  // style={{ position: 'sticky', left: 0, zIndex: 5 }}
                  className={
                    index
                      ? 'violet-sticky'
                      : 'buffet-report-page-table-category-title'
                  }
                >
                  {t(item?.name)}
                </div>
              ),
            },
            {
              renderItem: (item) => <div>{item?.categoryName}</div>,
            },
            {
              renderItem: (item) => <div></div>,
            },
            {
              renderItem: () => <div className={`text-end`}></div>,
            },
            {
              renderItem: () => <div className={`text-end`}></div>,
            },
            {
              renderItem: () => <div />,
            },
            {
              renderItem: () => <div className={`text-end`}></div>,
            },
            {
              renderItem: () => <div className={`text-end`}></div>,
            },
            {
              renderItem: () => <div className={`text-end`}></div>,
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>{item.dimensionsCount}</div>
              ),
            },
            {
              renderItem: () => <div className={`text-end`}></div>,
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>
                  {item?.plannedWeight
                    .toFixed(3)
                    .toString()
                    .replace(/[.]/g, ',')}
                </div>
              ),
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>{item?.plannedPersonsAmount}</div>
              ),
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>
                  {item?.plannedWeightPerPerson
                    .toFixed(3)
                    .toString()
                    .replace(/[.]/g, ',')}
                </div>
              ),
            },
            {
              renderItem: () => <div className={`text-end`}></div>,
            },
            {
              renderItem: () => <div className={`text-end`}></div>,
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>
                  {item?.dimensionWeight
                    .toFixed(3)
                    .toString()
                    .replace(/[.]/g, ',')}
                </div>
              ),
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>
                  {item?.actualWeight
                    .toFixed(3)
                    .toString()
                    .replace(/[.]/g, ',')}
                </div>
              ),
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>{+item?.actualPersonsAmount}</div>
              ),
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>
                  {item?.actualWeightPerPerson
                    .toFixed(3)
                    .toString()
                    .replace(/[.]/g, ',')}
                </div>
              ),
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>{item?.personsAmountDiff}</div>
              ),
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>
                  {item?.weightDiff?.toFixed(3).toString().replace(/[.]/g, ',')}
                </div>
              ),
            },
            {
              renderItem: (item) => (
                <>
                  <div className={`text-end`}>
                    {item.standardTempMin}
                    {item.standardTempMin && item.standardTempMax && (
                      <span> - </span>
                    )}
                    {item.standardTempMax}
                  </div>
                </>
              ),
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>
                  {!!(
                    (item.standardTempMin || item.standardTempMin === 0) &&
                    (item.standardTempMax || item.standardTempMax === 0)
                  ) ? (
                    <>
                      <ReportTempView
                        value={item.temperatureMin}
                        min={item.standardTempMin}
                        max={item.standardTempMax}
                      />{' '}
                      {item.temperatureAvg !== null && (
                        <>
                          {'- '}
                          <ReportTempView
                            value={item.temperatureAvg}
                            min={item.standardTempMin}
                            max={item.standardTempMax}
                          />
                        </>
                      )}
                      {item.temperatureMax !== null && (
                        <>
                          {'- '}
                          <ReportTempView
                            value={item.temperatureMax}
                            min={item.standardTempMin}
                            max={item.standardTempMax}
                          />
                        </>
                      )}
                    </>
                  ) : (
                    <div style={{ minWidth: 150 }}>
                      {`${item.temperatureMin
                        .toFixed(2)
                        .toString()
                        .replace(/[.]/g, ',')}-${item.temperatureAvg
                        .toFixed(2)
                        .toString()
                        .replace(/[.]/g, ',')}-${item.temperatureMax
                        .toFixed(2)
                        .toString()
                        .replace(/[.]/g, ',')}`}
                    </div>
                  )}
                </div>
              ),
            },
            {
              renderItem: () => <div className={`text-end`}></div>,
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>
                  <ImagePreviewWrapper
                    className={'report-image-preview'}
                    onClick={() => {
                      setSearchParams((sp) => {
                        sp.set('report-image-id', item.id.toString())
                        return sp
                      })
                    }}
                    isReportPageItem={true}
                    image={item.imageOnS3 || item.image}
                    size={ImagePreviewWrapperSizeEnum.MEDIUM}
                  />
                </div>
              ),
            },
          ]}
          subTableRepresent={subTableRepresentFn}
          headerData={headerDataDnd}
        />
      )}
    </React.Fragment>
  )
}
